import styled from "styled-components";
import { useEffect, useState, useContext } from "react";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { DialogWindowContext } from "../../../../Contexts/DialogueWindowContext";
import { OrgTreeContext } from "../../../../Contexts/OrgTreeContext";
import {
  findParentNode,
  moveNodeInTree,
} from "../../../../Helpers/OrgTreeFunctions";
import OrgTreeSelect from "../../../UI/OrgTreeSelect/OrgTreeSelect";
import TeamtypeEdit from "./TeamTypeEdit";
import { saveOrgTree } from "../../../../Firebase";

const UserEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  margin: 0 auto;
  min-width: 300px;
  align-items: flex-start;
  p {
    font-size: 12px;
    margin-top: 5px;
  }
  .p-inputtext {
    margin: 2px 0 5px 0;
  }
  .p-inputtext,
  .p-treeselect,
  .p-inputwrapper {
    width: 270px;
  }
  .p-inputswitch {
    margin: 5px 0;
  }
`;

export default function AddTeamMemeber(props: Props) {
  const { selectedTeam } = props;
  const [teamSettings, setTeamSettings] = useState<OrgTreeItem>();
  const DialogWindow = useContext(DialogWindowContext);
  const orgTreeDatabase = useContext(OrgTreeContext);
  const [parentTeam, setParentTeam] = useState<OrgTreeItem>();

  useEffect(() => {
    if (selectedTeam && orgTreeDatabase) {
      const parentOfPropNode = findParentNode(orgTreeDatabase, selectedTeam);
      parentOfPropNode && setParentTeam(parentOfPropNode);
    }
  }, [selectedTeam, orgTreeDatabase]);

  useEffect(() => {
    if (selectedTeam) {
      setTeamSettings(selectedTeam);
    }
  }, [selectedTeam]);

  const saveDetails = () => {
    if (orgTreeDatabase && teamSettings && parentTeam) {
      const newOrgTree = moveNodeInTree(
        orgTreeDatabase,
        teamSettings,
        parentTeam
      );
      newOrgTree && console.log(newOrgTree)
      newOrgTree && saveOrgTree(newOrgTree);
    }
    DialogWindow.setDialogProps({
      ...DialogWindow,
      showEditWindow: false,
    });
  };

  const inputChange = (e: any) => {
    if (e.target.id.includes("teamName")) {
      setTeamSettings((prevSettings) => ({
        ...prevSettings!,
        label: e.target.value,
      }));
    }
  };

  return (
    <UserEditWrapper>
      {teamSettings && (
        <>
          <p>Team Name</p>
          <InputText
            id="teamName"
            value={teamSettings && teamSettings.label}
            onChange={(e) => inputChange(e)}
          />

          <p>Team Type</p>
          <TeamtypeEdit
            teamType={teamSettings.teamType}
            setTeamType={(teamType: TeamType) => {
              setTeamSettings((prevSettings) => ({
                ...prevSettings!,
                teamType: teamType,
              }));
            }}
          />
          <p>Active Team</p>
          <InputSwitch
            checked={teamSettings.visible}
            onChange={() => {
              setTeamSettings((prevSettings) => ({
                ...prevSettings!,
                visible: !teamSettings.visible,
              }));
            }}
          />

          <p>Parent Team</p>
          <OrgTreeSelect selectedTeam={parentTeam} teamSelect={setParentTeam} />

          <Button
            label="Save"
            style={{ marginTop: "10px", border: "none" }}
            severity="success"
            icon="pi pi-check"
            onClick={saveDetails}
          />
        </>
      )}
    </UserEditWrapper>
  );
}

interface Props {
  selectedTeam: OrgTreeItem;
}
